import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[axisRange]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: AxisRangeValidatorDirective,
      multi: true
    }
  ]
})
export class AxisRangeValidatorDirective implements Validator {
  @Input() axisRange: Array<number>;
  validate(control: AbstractControl): { [key: string]: any } {
    if (!this.axisRange) {
      return null;
    } else {
      return control.value >= this.axisRange[0] &&
        control.value <= this.axisRange[1]
        ? null
        : {
            axisRange: {
              valid: false
            }
          };
    }
  }
}
